import Swiper, { Navigation } from "swiper";
import { isMobile } from "@src/utils/matchMedia";

import "./index.css";

export function setupProperty() {
  const container = document.querySelector(".container-property");

  if (container == null) {
    return;
  }

  let swiperInstance: Swiper | null = null;

  const toggleSwiper = () => {
    if (isMobile()) {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    } else {
      if (!swiperInstance) {
        swiperInstance = new Swiper(".container-property-swiper", {
          slidesPerView: "auto",
          spaceBetween: 24,
          modules: [Navigation],
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }
    }
  };

  toggleSwiper();

  window.addEventListener("resize", toggleSwiper);
}
